import * as i0 from '@angular/core';
import { Injectable, NgModule } from '@angular/core';
import * as i1 from '@angular/common/http';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { map } from 'rxjs/operators';

/* eslint-disable @typescript-eslint/explicit-member-accessibility */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common/http';
var ApiVersion;
(function (ApiVersion) {
    ApiVersion["v1"] = "v1";
    ApiVersion["v2"] = "v2";
    ApiVersion["v3"] = "v3";
    ApiVersion["v4"] = "v4";
})(ApiVersion || (ApiVersion = {}));
class UrlBase {
    /**
     *
     * @param version - v1, v2, v3, or v4
     */
    static getBaseUrl(version) {
        return `/api/qbo-integration/${version}/`;
    }
}

class LicenseAgreementService {
    constructor(http) {
        this.http = http;
    }
    // get accepted license agreement for the given agreeingEntityId
    getAcceptedLicenseAgreement(agreeingEntityId) {
        const url = `${UrlBase.getBaseUrl(ApiVersion.v1)}accepted-license-agreement/${agreeingEntityId}`;
        return this.http.get(url).pipe(map((response) => response));
    }
    // save accepted license agreement for the given agreeingEntityId
    saveAcceptedLicenseAgreement(licenseAgreementParameter) {
        const url = `${UrlBase.getBaseUrl(ApiVersion.v1)}accepted-license-agreement`;
        return this.http.post(url, licenseAgreementParameter).pipe(map((response) => response));
    }
}
LicenseAgreementService.ɵfac = function LicenseAgreementService_Factory(t) { return new (t || LicenseAgreementService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient)); };
LicenseAgreementService.ɵprov = i0.ɵɵdefineInjectable({ factory: function LicenseAgreementService_Factory() { return new LicenseAgreementService(i0.ɵɵinject(i1.HttpClient)); }, token: LicenseAgreementService, providedIn: "root" });
LicenseAgreementService.ctorParameters = () => [
    { type: HttpClient }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LicenseAgreementService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }]; }, null); })();

class LinkSessionService {
    constructor(http) {
        this.http = http;
    }
    // generate the link session id with the given linksession parameters
    generateLinkSessionId(linkSessionParameters) {
        const url = `${UrlBase.getBaseUrl(ApiVersion.v1)}generate-link-session`;
        return this.http.post(url, linkSessionParameters).pipe(map((response) => response));
    }
}
LinkSessionService.ɵfac = function LinkSessionService_Factory(t) { return new (t || LinkSessionService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient)); };
LinkSessionService.ɵprov = i0.ɵɵdefineInjectable({ factory: function LinkSessionService_Factory() { return new LinkSessionService(i0.ɵɵinject(i1.HttpClient)); }, token: LinkSessionService, providedIn: "root" });
LinkSessionService.ctorParameters = () => [
    { type: HttpClient }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LinkSessionService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }]; }, null); })();

class RequestGrantService {
    constructor(http) {
        this.http = http;
    }
    // deletes the existing grant in the database
    revokeGrant(supportedApplicationId, applicationQboEntityId) {
        const body = {
            supportedApplicationId,
            applicationQboEntityId,
        };
        const url = `${UrlBase.getBaseUrl(ApiVersion.v2)}grant/revoke`;
        return this.http.post(url, body);
    }
    // gets the grant token stored in the backend to check for success for QBO process
    getGrantToken(grantTokenParameters) {
        const url = `${UrlBase.getBaseUrl(ApiVersion.v1)}grant/complete-grant`;
        return this.http.post(url, grantTokenParameters).pipe(map((response) => response));
    }
}
RequestGrantService.ɵfac = function RequestGrantService_Factory(t) { return new (t || RequestGrantService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient)); };
RequestGrantService.ɵprov = i0.ɵɵdefineInjectable({ factory: function RequestGrantService_Factory() { return new RequestGrantService(i0.ɵɵinject(i1.HttpClient)); }, token: RequestGrantService, providedIn: "root" });
RequestGrantService.ctorParameters = () => [
    { type: HttpClient }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RequestGrantService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }]; }, null); })();

class AccessTokenService {
    constructor(http) {
        this.http = http;
    }
    validateAccessToken(supportedApplicationId, applicationQboEntityId) {
        const accessTokenBody = {
            supportedApplicationId,
            applicationQboEntityId,
        };
        const url = `${UrlBase.getBaseUrl(ApiVersion.v2)}validate-access-token`;
        return this.http.post(url, accessTokenBody);
    }
}
AccessTokenService.ɵfac = function AccessTokenService_Factory(t) { return new (t || AccessTokenService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient)); };
AccessTokenService.ɵprov = i0.ɵɵdefineInjectable({ factory: function AccessTokenService_Factory() { return new AccessTokenService(i0.ɵɵinject(i1.HttpClient)); }, token: AccessTokenService, providedIn: "root" });
AccessTokenService.ctorParameters = () => [
    { type: HttpClient }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AccessTokenService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }]; }, null); })();

class QboPreferencesService {
    constructor(http) {
        this.http = http;
    }
    // This endpoint returns the Accounting Method for the QBO Company linked to applicationQboEntityId
    // supportedApplicationId identifies the application calling the endpoint
    // applicationQboEntityId is the entity linked to the QBO Company
    getAccountingMethod(supportedApplicationId, applicationQboEntityId) {
        let url = `${UrlBase.getBaseUrl(ApiVersion.v1)}qbo-data/preferences/accounting-method`;
        url += `?supportedApplicationId=${supportedApplicationId}&applicationQboEntityId=${applicationQboEntityId}`;
        return this.http.get(url);
    }
}
QboPreferencesService.ɵfac = function QboPreferencesService_Factory(t) { return new (t || QboPreferencesService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient)); };
QboPreferencesService.ɵprov = i0.ɵɵdefineInjectable({ factory: function QboPreferencesService_Factory() { return new QboPreferencesService(i0.ɵɵinject(i1.HttpClient)); }, token: QboPreferencesService, providedIn: "root" });
QboPreferencesService.ctorParameters = () => [
    { type: HttpClient }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(QboPreferencesService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }]; }, null); })();

class QuickbooksReportDataService {
    constructor(http) {
        this.http = http;
    }
    // This endpoint returns the Account Details along with account balances from QBO services
    // for the QBO Company linked to applicationQboEntityId with the options passed in with the params object
    getQuickbooksReportData(reportDataParams) {
        let url = `${UrlBase.getBaseUrl(ApiVersion.v1)}qbo-data/qbo-accountdata-reports`;
        url += `?startDate=${reportDataParams.startDate}&`;
        url += `endDate=${reportDataParams.endDate}&`;
        url += `accountingMethod=${reportDataParams.accountingMethod}&`;
        url += `includeExcludeZeroBalance=${reportDataParams.includeExcludeZeroBalance}&`;
        url += `accountActivitiesOnly=${reportDataParams.accountActivitiesOnly.toString()}&`;
        url += `supportedApplicationId=${reportDataParams.supportedApplicationId}&`;
        url += `applicationQboEntityId=${reportDataParams.applicationQboEntityId}`;
        return this.http.get(url).pipe(map((response) => response));
    }
    // This endpoint returns the companyInfo for the QBO Company linked to applicationQboEntityId
    // supportedApplicationId identifies the application calling the endpoint
    // applicationQboEntityId is the entity linked to the QBO Company
    getQboCompanyInfo(supportedApplicationId, applicationQboEntityId) {
        const url = `${UrlBase.getBaseUrl(ApiVersion.v1)}qbo-data/companyInfo`;
        const requestBody = {
            supportedApplicationId: supportedApplicationId,
            applicationQboEntityId: applicationQboEntityId,
        };
        return this.http.post(url, requestBody).pipe(map((response) => response));
    }
}
QuickbooksReportDataService.ɵfac = function QuickbooksReportDataService_Factory(t) { return new (t || QuickbooksReportDataService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient)); };
QuickbooksReportDataService.ɵprov = i0.ɵɵdefineInjectable({ factory: function QuickbooksReportDataService_Factory() { return new QuickbooksReportDataService(i0.ɵɵinject(i1.HttpClient)); }, token: QuickbooksReportDataService, providedIn: "root" });
QuickbooksReportDataService.ctorParameters = () => [
    { type: HttpClient }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(QuickbooksReportDataService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }]; }, null); })();

class QuickbooksOnlineServicesModule {
}
QuickbooksOnlineServicesModule.ɵfac = function QuickbooksOnlineServicesModule_Factory(t) { return new (t || QuickbooksOnlineServicesModule)(); };
QuickbooksOnlineServicesModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: QuickbooksOnlineServicesModule });
QuickbooksOnlineServicesModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        LinkSessionService,
        RequestGrantService,
        LicenseAgreementService,
        AccessTokenService,
        QboPreferencesService,
        QuickbooksReportDataService,
    ], imports: [[HttpClientModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(QuickbooksOnlineServicesModule, [{
        type: NgModule,
        args: [{
                declarations: [],
                imports: [HttpClientModule],
                exports: [],
                providers: [
                    LinkSessionService,
                    RequestGrantService,
                    LicenseAgreementService,
                    AccessTokenService,
                    QboPreferencesService,
                    QuickbooksReportDataService,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(QuickbooksOnlineServicesModule, { imports: function () { return [HttpClientModule]; } }); })();

class DtoBase {
}

class LinkSession extends DtoBase {
}

class LinkSessionParameters {
}

class LicenseAgreement extends DtoBase {
}

class LicenseAgreementParameter {
}

class AccessTokenParamaters {
}

class RevokeGrantParamaters {
}

class GrantToken extends DtoBase {
}

class GrantTokenParameters {
}

var AccountingMethod;
(function (AccountingMethod) {
    AccountingMethod["Cash"] = "Cash";
    AccountingMethod["Accrual"] = "Accrual";
})(AccountingMethod || (AccountingMethod = {}));

class QuickbooksReportDataParams extends DtoBase {
}

class QboAccountData {
}

var IncludeExcludeZeroBalance;
(function (IncludeExcludeZeroBalance) {
    IncludeExcludeZeroBalance["IncludeZeroBalance"] = "IncludeZeroBalance";
    IncludeExcludeZeroBalance["ExcludeZeroBalance"] = "ExcludeZeroBalance";
})(IncludeExcludeZeroBalance || (IncludeExcludeZeroBalance = {}));

/*
 * Public API Surface of quickbooks-online-services
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AccessTokenParamaters, AccessTokenService, AccountingMethod, GrantToken, GrantTokenParameters, IncludeExcludeZeroBalance, LicenseAgreement, LicenseAgreementParameter, LicenseAgreementService, LinkSession, LinkSessionParameters, LinkSessionService, QboAccountData, QboPreferencesService, QuickbooksOnlineServicesModule, QuickbooksReportDataParams, QuickbooksReportDataService, RequestGrantService, RevokeGrantParamaters, DtoBase as ɵa };

